/**
 * useFieldsQuery
 */
import React, {
    useMemo,
} from 'react';
import {
    Queries,
    ApolloLib,
} from 'bdvp-graphql';

const { useLazyQuery } = ApolloLib;
const { GET_FIELDS } = Queries;

const sanitizeIds = (ids) => {

    if (!Array.isArray(ids) || ids.length <= 0) {

        // Passing an empty array to the fields query will pull down ALL fields
        // we should never hit here, but better safe than sorry
        return [1];

    }

    // remove duplicates
    return [...new Set(ids)];

};

const useFieldsQuery = (fieldIdsWithValues, fieldIdsWithoutValues) => {

    const [
        loadFields,
        {
            called,
            loading,
            data: splitData,
            error,
        },
    ] = useLazyQuery(
        GET_FIELDS,
        {
            variables: {
                ids: sanitizeIds(fieldIdsWithValues),
                idsSkipValues: sanitizeIds(fieldIdsWithoutValues),
            },
        }
    );

    const data = useMemo(() => {

        return splitData
            ? {
                fields: [
                    ...(splitData.withValues || []),
                    ...(splitData.withoutValues || []),
                ],
            }
            : undefined;

    },[splitData]);

    return {
        loadFields,
        called,
        loading,
        data,
        error,
    };

};

export default useFieldsQuery;
